import { Tabs } from 'antd';
import React, { useState } from 'react';
import BSTransactionCryptoHistoryTable from './BSTransactionCryptoHistoryTable';
import BSTransactionHistoryTable from './BSTransactionHistoryTable';
import GenericButton from '../updated/shared/Button';
import DownloadReportPopup from './DownloadReportPopup';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: any) => ({
  link: {
    fontWeight: 500,
    background: 'none',
    width: 'fit-content',
    border: 'none',
    padding: '0px',
    fontSize: '16px',
    lineHeight: '22px',
    marginBottom: '20px',
    cursor: 'pointer',
    color: `${theme.palette.text.secondary} !important`,
    '&:hover': {
      color: `${theme.palette.text.primary} !important`,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
}));
const BSTransactionHistoryContent = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (window.history.length > 2) {
      navigate(-1); // Goes back to the previous page in history
    } else {
      navigate('/'); // Redirects to home if there's no history
    }
  };
  const [pdfDownload, setPdfDownload] = useState(false);
  const [fiatTransactions, setFiatTransactions] = useState<any[]>([]);
  const [cryptoTransactions, setCryptoTransactions] = useState<any[]>([]);
  const [currentTab, setCurrentTab] = useState('crypto');

  const handleFiatDataChange = (data: any[]) => {
    setFiatTransactions(data);
  };

  const handleCryptoDataChange = (data: any[]) => {
    setCryptoTransactions(data);
  };

  const handleTabChange = (activeKey: string) => {
    setCurrentTab(activeKey === '1' ? 'crypto' : 'fiat');
  };

  return (
    <div className="container flex-align-stretch bs_main width-100 large_card position-relative  ">
      <div>
        {' '}
        <div className={classes.link} onClick={handleGoBack}>
          <ArrowBackIcon /> Go Back
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h1>Transaction History</h1>
        <GenericButton
          text={'Download Report'}
          IconComponent={undefined}
          onClick={() => setPdfDownload(true)}
          className={undefined}
          styles={{ width: 'fit-content' }}
          disabled={undefined}
          loading={undefined}
        />
      </div>

      <div>
        <Tabs
          type="line"
          defaultActiveKey="1"
          className="bs_tab_item orange tabs_button"
          onChange={handleTabChange}
        >
          <Tabs.TabPane tab="Crypto" key="1">
            <BSTransactionCryptoHistoryTable
              onDataChange={handleCryptoDataChange}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Fiat" key="2">
            <BSTransactionHistoryTable onDataChange={handleFiatDataChange} />
          </Tabs.TabPane>
        </Tabs>
      </div>
      {pdfDownload && (
        <DownloadReportPopup
          onClose={() => setPdfDownload(false)}
          fiatTransactions={fiatTransactions as any}
          cryptoTransactions={cryptoTransactions as any}
          currentTab={currentTab}
        />
      )}
      {/* <Button className='disabled_button ant-btn ant-btn-dangerous danger_disabled width_auto margin-r-2x position-absolute reset_button' onClick={() => window.location.reload()}> reset </Button> */}
    </div>
  );
};

export default BSTransactionHistoryContent;